import * as S from './styles';
import FilterItem from '@/components/exportData/panel/DimensionEditor/FilterItem';

// import { FILTER_KEYS } from '@/utils/consts';
import {
    DEFUALT_OR_CONDITION,
    LOGICAL_OPERATOR,
    OUTER_CONDITIONS_PATH,
} from '@/components/Dashboard/common/Filter/const';
import {
    // checkHasLevel,
    getOuterConditions,
} from '@/components/Dashboard/common/Filter/utils';
import CommonButton from '@design/components/button/Button';
import InputField from '@/components/Common/InputField';
import PlusIcon from '@svgIcons/plus.svg';

import { FLEX_DIV } from '@styles/common.styled.component';
import { getPrefix } from '@/components/Dashboard/common/UaFilterSettingPanel';

export default {
    name: 'FilterGroup',
    props: {
        customFieldValue: {
            type: String,
        },
        filterGroupData: {
            type: Array,
            default: () => [],
        },
        groupIdx: { type: Number },
        filterList: {
            type: Array,
        },
        updateFilterList: {
            type: Function,
        },
        genericLevelOptions: {
            type: Array,
            default: () => [],
        },
        discardFieldOptions: {
            type: Array,
            default: () => [],
        },
        discardGenericLevelOptions: {
            type: Array,
            default: () => [],
        },
        breakdownListByChannel: {
            type: Object,
            default: () => ({}),
        },
        categoryListByPrefix: {
            type: Object,
            default: () => ({}),
        },
        isElseGroup: {
            type: Boolean,
            default: false,
        },
        setElseCasePresent: {
            type: Function,
            default: () => false,
        },
        genericLevelTranslator: {
            type: Function,
            default: R.identity,
        },
    },
    computed: {
        groupSourceType() {
            const { filterGroupData } = this;

            const firstData = R.head(filterGroupData);

            const isGeneric = R.propEq('dataSourceType', 'generic', firstData);

            if (!isGeneric) return;

            return R.compose(getPrefix, R.propOr('', 'field'))(firstData);
        },
    },
    methods: {
        selectGroup() {
            this.$emit('select', this.groupIdx);
        },
        handleCustomFieldValue(value) {
            const groupPath = [0, 'conditions', this.groupIdx];

            const groupData = R.pathOr(
                [DEFUALT_OR_CONDITION],
                groupPath,
                this.filterList
            );

            const newFilterGroupData = R.assoc(
                'customFieldValue',
                value,
                groupData || {
                    ...DEFUALT_OR_CONDITION,
                    customFieldValue: value,
                }
            );

            const updatedFilters = R.assocPath(
                groupPath,
                newFilterGroupData,
                this.filterList
            );

            this.updateFilterList(updatedFilters);
        },
        handleRemoveFilterGroup() {
            if (this.isElseGroup) {
                this.$emit('setElseCasePresent', false);
            }
            const conditions = getOuterConditions(this.filterList);

            let updatedConditions = conditions.filter(
                (_, idx) => idx !== this.groupIdx
            );

            if (updatedConditions.length === 0) {
                updatedConditions = [DEFUALT_OR_CONDITION];
            }

            const updatedFilters = R.assocPath(
                OUTER_CONDITIONS_PATH,
                updatedConditions,
                this.filterList
            );

            this.updateFilterList(updatedFilters);
        },
        handleAddFilterItem() {
            const conditions = getOuterConditions(this.filterList);

            const updatedConditions = conditions.map((filterGroup, idx) => {
                if (idx === this.groupIdx) {
                    const { conditions } = filterGroup;
                    const updatedConditions = R.append({}, conditions);
                    return R.assoc(
                        'conditions',
                        updatedConditions,
                        filterGroup
                    );
                } else {
                    return filterGroup;
                }
            });

            const updatedFilters = R.assocPath(
                OUTER_CONDITIONS_PATH,
                updatedConditions,
                this.filterList
            );

            this.updateFilterList(updatedFilters);
        },
    },
    render() {
        const {
            discardFieldOptions: _discardFieldOptions,
            filterGroupData,
            filterList,
            groupIdx,
            groupSourceType,
            breakdownListByChannel,
            categoryListByPrefix,
            isElseGroup,
            genericLevelOptions,
            genericLevelTranslator,
        } = this;

        const filterItemsDom$ = filterGroupData.map((filterData, itemIdx) => (
            <FilterItem
                filterData={filterData}
                path={[0, 'conditions', groupIdx, 'conditions', itemIdx]}
                filterList={filterList}
                updateFilterList={this.updateFilterList}
                breakdownListByChannel={breakdownListByChannel}
                categoryListByPrefix={categoryListByPrefix}
                discardFieldOptions={_discardFieldOptions}
                groupSourceType={groupSourceType}
                groupIdx={groupIdx}
                genericLevelOptions={genericLevelOptions}
                genericLevelTranslator={genericLevelTranslator}
            />
        ));

        const contentDom$ = R.intersperse(
            <S.AddBtn>
                {this.$t(`FILTERS.logical_operator_${LOGICAL_OPERATOR.and}`)}
            </S.AddBtn>,
            filterItemsDom$
        );

        return isElseGroup ? (
            <S.FilterGroupWrapper onClick={this.selectGroup}>
                <S.FilterGroupTitle>
                    <FLEX_DIV>ELSE</FLEX_DIV>
                    <S.ResetButton onClick={this.handleRemoveFilterGroup}>
                        {this.$t('NEW_DASHBOARD.ua_filter_setting_panel_reset')}
                    </S.ResetButton>
                </S.FilterGroupTitle>
                <S.FilterGroupValueWrapper>
                    <S.InputFieldWrapper>
                        <InputField
                            class="label-name-input-field"
                            value={this.customFieldValue}
                            placeholder={this.$t(
                                'EXPORT_DATA.custom_field_value'
                            )}
                            onInput={(value) => {
                                this.handleCustomFieldValue(value);
                            }}
                        />
                    </S.InputFieldWrapper>
                </S.FilterGroupValueWrapper>
            </S.FilterGroupWrapper>
        ) : (
            <S.FilterGroupWrapper onClick={this.selectGroup}>
                <S.FilterGroupTitle>
                    <FLEX_DIV>IF {this.groupIdx + 1}</FLEX_DIV>
                    <S.ResetButton onClick={this.handleRemoveFilterGroup}>
                        {this.$t('NEW_DASHBOARD.ua_filter_setting_panel_reset')}
                    </S.ResetButton>
                </S.FilterGroupTitle>
                {contentDom$}
                <S.FilterGroupValueWrapper>
                    <S.InputFieldWrapper>
                        <InputField
                            class="label-name-input-field"
                            value={this.customFieldValue}
                            placeholder={this.$t(
                                'EXPORT_DATA.custom_field_value'
                            )}
                            onInput={(value) => {
                                this.handleCustomFieldValue(value);
                            }}
                        />
                    </S.InputFieldWrapper>
                </S.FilterGroupValueWrapper>
                <CommonButton
                    type="white"
                    css={S.ApplyAddBtnCss}
                    onClick={this.handleAddFilterItem}
                >
                    <PlusIcon v-view-box />
                    <div>
                        {this.$t(
                            `FILTERS.logical_operator_${LOGICAL_OPERATOR.and}`
                        )}
                    </div>
                </CommonButton>
            </S.FilterGroupWrapper>
        );
    },
};
